export default {"src":"/_next/static/media/close-icon.2cb39b65.svg","height":20,"width":20};